let util = {

};
util.title = function (title) {
    title = title ? title + ' - Home' : 'fancy视频转码系统';
    window.document.title = title;
};

export default util;